import React from 'react';
import * as LucideIcons from 'lucide-react';

const AmenitySelector = ({ amenities, onChange, onBlur }) => {
  const toggleAmenity = (id) => {
    const updatedAmenities = amenities.map((amenity) =>
      amenity.id === id ? { ...amenity, selected: !amenity.selected } : amenity
    );
    onChange(updatedAmenities);
  };

  // Dynamic icon component
  const DynamicIcon = ({ iconName }) => {
    const IconComponent = LucideIcons[iconName.charAt(0).toUpperCase() + iconName.slice(1)];
    return IconComponent ? <IconComponent className="w-5 h-5" /> : null;
  };

  return (
    <div className="w-full" onBlur={onBlur}>
      <h3 className="text-sm font-medium text-gray-700 mb-3">Amenities</h3>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 gap-3">
        {amenities?.map((amenity) => (
          <button
            key={amenity.id}
            type="button"
            onClick={() => toggleAmenity(amenity.id)}
            className={`flex items-center gap-2 p-3 rounded-lg transition-all text-left text-sm
              ${
                amenity.selected
                  ? 'bg-timeless/10 border border-blue-500 text-timeless shadow-sm'
                  : 'bg-white border border-gray-200 text-gray-700 hover:border-timeless/20 hover:bg-timeless/5'
              }
            `}
          >
            <div className={`flex-shrink-0 p-2 rounded-full ${amenity.selected ? 'bg-timeless/10' : 'bg-gray-100'}`}>
              <DynamicIcon iconName={amenity.icon} />
            </div>
            <span>{amenity.name.en}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default AmenitySelector;
